import { render, staticRenderFns } from "./QrCodeBox.vue?vue&type=template&id=22b92d65&scoped=true"
import script from "./QrCodeBox.vue?vue&type=script&lang=js"
export * from "./QrCodeBox.vue?vue&type=script&lang=js"
import style0 from "./QrCodeBox.vue?vue&type=style&index=0&id=22b92d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b92d65",
  null
  
)

export default component.exports